const getters = {
  totalPage: state => {
    return Math.ceil(state.member.skuTotal / 10)
  },
  specialList: state => {
    // console.log('specialList',state.member.goodsList)
    let special = state.member.goodsList.slice(0,3)
    return special
  },
  buyslow: state => {
    let sheng = state.member.goodsList.slice(3,5)
    // let sheng = state.member.goodsList.slice(2,3)
    return sheng
  },
  todayStar: state => {
    let star = state.member.goodsList.slice(5,9)
    return star
  },
  actGoodsList: state => {
    let actGoods = state.member.goodsList.slice(9,13)
    return actGoods
  },
  collageList: state => {
    let lastList = state.member.skuList;
    return lastList.splice(0,2)
  },
  leftList: state => {
    let lastList = state.member.skuList
    if(!lastList.length){
      return
    }
    return lastList.filter((item,index)=>{
      if(index%2 === 0){
        return item
      }
    })
  },
  rightList: state => {
    let lastList = state.member.skuList
    if(!lastList.length){
      return
    }
    return lastList.filter((item,index)=>{
      if(index%2 !== 0){
        return item
      }
    })
  },

  goodsList: state => {
    return state.order.orderConfirmData.itemInfo ? state.order.orderConfirmData.itemInfo.itemList : []
  },

  shipmentMethod: state => {
    return state.order.orderConfirmData.shipmentMethod || 2
  },

  totalAmount: state => {
    return state.order.orderConfirmData.totalAmount
  },
  discountAmount: state => {
    return state.order.orderConfirmData.discountAmount
  },
  cashAmount: state => {
    return state.order.orderConfirmData.cashAmount
  },

  balance: state => {
    return parseInt(state.order.orderConfirmData.maxPoint) || 0
  },
  consigneeParam: state => {
    return state.order.orderConfirmData.consigneeParam
  },
  depotResponse: state => {
    return state.order.orderConfirmData.depotResponse
  },
  pintuanInfo: state => {
    return state.order.orderConfirmData.pintuanInfo || null
  },
  newInfo:state=>state.order.orderConfirmData.itemNewUserExclusiveVo || null,
  /**
   * @description 获取新人活动首页列表
   */
  newUserList:state=>state.member.newerList.splice(0,3),
  isNewer:state=>state.user.isNewer,
  isLogin: (state) => state.user.isLogin,
  // this.goodsList = result.goodListResponse ? result.goodListResponse.goodList : [];
  // this.shipmentMethod = result.shipmentMethod;
  // this.totalAmount = result.totalAmount; //
  // this.discountAmount = result.discountAmount;
  // this.cashAmount = result.cashAmount;
  // this.balance = parseInt(result.maxPoint);
  // this.consigneeParam = result.consigneeParam
  // this.depotResponse = result.depotResponse
  showModules:state=>state.app.showModules
};
export default getters;